import { Media } from "../../media";
import { Account } from "./account";

export interface Audit {
  createdBy: Account;
  createdAt: Date;
  updatedBy: Account;
  updatedAt: Date;
  avatar?: Media;
}